import * as React from 'react';
import Svg, {
  SvgProps, G, Path, Defs, LinearGradient, Stop, ClipPath,
} from 'react-native-svg';

const LoginImage = (props: SvgProps) => (
  <Svg width={210} height={227} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        opacity={0.096}
        d="m167.849 178.688-47.664-27.519c-1.417-.819-1.238-2.262.4-3.207l46.535-26.868c1.637-.946 4.137-1.049 5.555-.231l47.665 27.519c1.417.819 1.238 2.262-.4 3.207l-46.535 26.868c-1.638.946-4.138 1.049-5.556.231Z"
        fill="#D4D5D7"
      />
      <Path
        d="m181.738 62.542-41.721-24.087a8.264 8.264 0 0 0-.488-.304L74.455.581a4.329 4.329 0 0 0-6.494 3.748v98.144a11.083 11.083 0 0 0 5.54 9.594l73.916 42.676c.228.132.45.27.666.416l28.467 16.433a6.309 6.309 0 0 0 6.316 0 6.307 6.307 0 0 0 3.158-5.47V69.965a8.576 8.576 0 0 0-4.286-7.423Z"
        fill="#D4D5D7"
      />
      <Path
        d="M138.791 135.095c.228.131.45.27.666.415l28.466 16.435a6.318 6.318 0 0 0 9.474-5.471V77.529a8.576 8.576 0 0 0-4.286-7.424l-41.72-24.087a8.264 8.264 0 0 0-.488-.304L65.829 8.144a4.329 4.329 0 0 0-6.494 3.748v70.933a11.077 11.077 0 0 0 5.54 9.593l73.916 42.677Z"
        fill="#ECEDEE"
      />
      <Path
        d="M138.791 162.559c.228.132.45.271.666.416l28.466 16.435a6.318 6.318 0 0 0 9.475-5.47v-68.946a8.568 8.568 0 0 0-4.287-7.423l-41.72-24.087a8.317 8.317 0 0 0-.488-.304L65.829 35.609a4.329 4.329 0 0 0-6.494 3.749v70.932a11.082 11.082 0 0 0 5.54 9.593l73.916 42.676Z"
        fill="#ECEDEE"
      />
      <Path
        d="M131.002 64.649c.27.156.533.32.79.492l45.606 26.331V77.463a8.567 8.567 0 0 0-4.287-7.424l-41.72-24.087a8.264 8.264 0 0 0-.488-.304L65.829 8.078a4.329 4.329 0 0 0-6.494 3.75v11.448l71.667 41.373Z"
        fill="#323E48"
      />
      <Path
        d="m162.479 137.681-25.744-14.863c-1.591-.918-2.892-3.405-2.892-5.527V92.206c0-2.122 1.301-3.106 2.892-2.187l25.744 14.863c1.591.919 2.893 3.406 2.893 5.527v25.086c-.001 2.12-1.303 3.105-2.893 2.186Z"
        fill="#fff"
      />
      <Path
        d="M156.348 126.508c4.036-2.359 3.994-9.939-.093-16.93-4.086-6.991-10.671-10.746-14.708-8.386-4.036 2.359-3.994 9.939.093 16.93 4.087 6.991 10.672 10.746 14.708 8.386Z"
        fill="#323E48"
      />
      <Path
        d="M156.957 126.086c1.493-1.204 2.391-3.338 2.391-6.231a18.137 18.137 0 0 0-.979-5.621l-4.849-1.998-5.571 2.465v.298l9.008 11.087Z"
        fill="#6BCBB8"
      />
      <Path
        d="m147.948 114.7 13.427 2.49c-.9-5.309-3.881-10.928-7.804-14.894l-5.623 12.404ZM72.327 21.46c0 1.675-1.183 2.35-2.642 1.507a5.826 5.826 0 0 1-2.644-4.56c0-1.674 1.184-2.349 2.644-1.506a5.824 5.824 0 0 1 2.642 4.559Z"
        fill="#7E57C5"
      />
      <Path
        d="M79.423 25.615c0 1.675-1.184 2.35-2.643 1.507a5.823 5.823 0 0 1-2.643-4.56c0-1.674 1.183-2.35 2.643-1.506a5.824 5.824 0 0 1 2.643 4.559Z"
        fill="#6BCBB8"
      />
      <Path
        d="M86.517 29.77c0 1.674-1.183 2.349-2.642 1.506a5.825 5.825 0 0 1-2.643-4.559c0-1.675 1.183-2.35 2.643-1.507a5.825 5.825 0 0 1 2.642 4.56Z"
        fill="#F5B335"
      />
      <Path
        d="M70.346 80.179s2.99-3.828 8.504-1.008c4.217 2.156 1.999 2.032 7.057 3.53 2.983.885 7.613-4.37 14.97-1.13 13.321 5.867 17.964-6.293 23.753.306v31.082L70.346 84.85V80.18Z"
        fill="url(#b)"
      />
      <Path
        d="M70.346 85.025V53.974M83.867 91.67V60.618M97.388 98.703V67.652M110.909 105.728v-31.05M124.43 113.236V82.184"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m124.272 79.127-1.783-1.03a.858.858 0 0 1-.358-.684c0-.264.161-.385.358-.272l1.783 1.03a.87.87 0 0 1 .359.685c0 .263-.161.385-.359.27ZM124.123 114.802l-1.783-1.03-.016-.007-1.324-.764c-.197-.114-.359.008-.359.271a.862.862 0 0 0 .359.685l1.783 1.029.016.008 1.324.764c.198.114.359-.008.359-.271a.862.862 0 0 0-.359-.685ZM146.057 81.425l-3.229-1.865-.03-.013-2.398-1.384a.597.597 0 0 0-.106-.047l-1.957-1.13c-.01-.006-.019-.008-.03-.013l-2.397-1.385c-.356-.206-.65.015-.65.492a1.557 1.557 0 0 0 .65 1.24l3.229 1.866c.01.005.02.007.03.013l2.398 1.384c.033.019.069.035.106.047l1.957 1.13c.01.006.02.008.03.013l2.398 1.384c.355.207.649-.014.649-.49a1.557 1.557 0 0 0-.65-1.242ZM155.445 144.721l-3.229-1.865c-.01-.006-.02-.008-.03-.014l-2.398-1.384a.59.59 0 0 0-.106-.047l-1.957-1.13-.029-.012-1.921-1.11a.895.895 0 0 0-.07-.051l-3.229-1.865-.03-.012-2.398-1.385a.56.56 0 0 0-.106-.047l-1.957-1.13-.029-.013-2.398-1.385c-.355-.206-.649.015-.649.492.004.243.065.482.178.697.112.216.274.402.471.544l3.229 1.865.031.013 2.397 1.384c.034.019.07.035.106.047l1.957 1.13c.011.006.02.008.031.013l1.92 1.11a.685.685 0 0 0 .07.05l3.229 1.865c.01.006.02.008.03.014l2.398 1.384c.034.019.07.034.106.047l1.957 1.129c.01.006.02.008.03.014l2.398 1.384c.355.206.65-.014.65-.491a1.576 1.576 0 0 0-.179-.698 1.546 1.546 0 0 0-.473-.543ZM145.038 144.868l-3.229-1.865c-.011-.006-.02-.008-.03-.013l-2.398-1.384a.6.6 0 0 0-.107-.047l-1.956-1.13c-.01-.006-.019-.008-.03-.013l-2.398-1.385c-.355-.206-.649.015-.649.491a1.557 1.557 0 0 0 .649 1.243l3.23 1.865c.01.006.02.008.03.013l2.398 1.384a.56.56 0 0 0 .106.047l1.957 1.131.03.013 2.398 1.384c.355.206.649-.014.649-.491a1.565 1.565 0 0 0-.65-1.243ZM145.704 86.069l-3.229-1.865c-.01-.006-.019-.008-.03-.013l-2.397-1.385a.622.622 0 0 0-.107-.047l-1.956-1.13-.03-.013-2.398-1.384c-.355-.206-.649.014-.649.49a1.557 1.557 0 0 0 .649 1.242l3.229 1.865c.011.006.02.008.031.013l2.397 1.384c.034.02.07.035.107.047l1.956 1.13c.011.006.02.008.031.013l2.397 1.385c.356.206.65-.015.65-.491a1.557 1.557 0 0 0-.651-1.242ZM109.298 106.643l-1.782-1.029-.017-.007-1.324-.765c-.198-.113-.359.008-.359.271a.867.867 0 0 0 .359.685l1.783 1.03.017.007 1.323.764c.198.114.359-.008.359-.27a.856.856 0 0 0-.359-.686ZM95.451 99.126l-1.783-1.03-.017-.007-1.324-.765c-.197-.113-.358.008-.358.272a.862.862 0 0 0 .358.685l1.783 1.03.016.006 1.325.765c.197.114.358-.008.358-.271a.861.861 0 0 0-.358-.686ZM82.384 92.092l-1.783-1.03-.017-.007-1.324-.764c-.197-.114-.359.008-.359.271a.862.862 0 0 0 .36.685l1.782 1.03.016.007 1.325.764c.197.114.358-.008.358-.27a.864.864 0 0 0-.358-.686ZM110.55 72.573l-1.783-1.03a.859.859 0 0 1-.358-.685c0-.263.161-.385.358-.27l1.783 1.029a.87.87 0 0 1 .359.685c0 .262-.162.384-.359.27ZM97.13 66.09l-1.783-1.03a.863.863 0 0 1-.359-.685c0-.263.162-.385.359-.27l1.783 1.028a.862.862 0 0 1 .359.686c0 .261-.162.383-.359.27ZM83.516 59.44l-1.783-1.03a.862.862 0 0 1-.359-.685c0-.263.161-.385.359-.271l1.783 1.03a.862.862 0 0 1 .359.684c0 .265-.162.387-.36.271ZM70.103 52.702l-1.783-1.03a.862.862 0 0 1-.358-.685c0-.263.16-.385.358-.27l1.783 1.029a.862.862 0 0 1 .359.685c0 .263-.162.385-.359.27Z"
        fill="#fff"
      />
      <Path
        d="m116.705 133.988 1.619 3.908a3.379 3.379 0 0 0 3.007 2.079 3.377 3.377 0 0 0 3.134-1.882l5.32-10.813-2.199-.503-7.216 7.904-3.665-.693ZM95.965 125.714l-3.788 14.792c-.206.773-1.501 11.443-1.501 11.443l-2.504-.499s-.234-11.317-.155-12.064l2.57-13.893 5.378.221Z"
        fill="#FBDDD3"
      />
      <Path
        d="M87.988 153.458a1.767 1.767 0 0 0 3.521-.297l-.107-1.27a1.767 1.767 0 0 0-3.52.297l.106 1.27ZM127.462 127.801a1.767 1.767 0 0 0 2.352.846l1.153-.542a1.767 1.767 0 0 0 .846-2.352v-.001a1.767 1.767 0 0 0-2.352-.846l-1.153.543a1.767 1.767 0 0 0-.846 2.352Z"
        fill="#FBDDD3"
      />
      <Path
        d="m111.002 126.487 3.69 10.46c.523.811 8.07-3.008 7.426-4.255-.113-.222-4.129-12.853-8.452-14.893-3.509-1.656-4.604 3.923-2.664 8.688ZM99.012 124.11l-3.69 10.459c-.524.812-8.071-3.008-7.427-4.254.114-.222 4.13-12.853 8.453-14.892 3.508-1.658 4.603 3.922 2.664 8.687Z"
        fill="#D1D4D7"
      />
      <Path
        d="m105.996 117.554-.297-.019a1.838 1.838 0 0 1-1.256-.617 1.836 1.836 0 0 1-.454-1.323l.355-5.659a1.832 1.832 0 0 1 1.94-1.71l.297.018a1.834 1.834 0 0 1 1.71 1.94l.457 5.489c-.062 1.004-1.748 1.944-2.752 1.881Z"
        fill="#FBDDD3"
      />
      <Path
        d="M108.176 112.672c1.784-.07 3.129-2.679 3.004-5.825-.125-3.147-1.672-5.64-3.456-5.569-1.783.07-3.128 2.678-3.003 5.825.125 3.147 1.672 5.64 3.455 5.569Z"
        fill="#FBDDD3"
      />
      <Path
        d="M110.831 104.615a4.794 4.794 0 0 0-4.202-1.297l1.28-2.039s2.102-.527 2.922 3.336Z"
        fill="#715154"
      />
      <Path
        d="M103.268 106.897c.83-1.311 2.869-1.377 5.854-.467 2.689-.035 2.833-3.126 2.833-3.126.302-1.664-.833-2.321-2.498-2.624l-4.334-.789c-2.453-.46-4.636 1.691-4.939 3.356l-.091.277c-.304 1.664 1.511 3.069 3.175 3.373Z"
        fill="#323E48"
      />
      <Path
        opacity={0.395}
        d="M107.248 197.85c6.591-.117 11.888-2.866 11.83-6.141-.058-3.274-5.449-5.834-12.041-5.717-6.591.117-11.888 2.866-11.83 6.141.058 3.274 5.449 5.834 12.041 5.717Z"
        fill="#D4D5D7"
      />
      <Path
        d="m118.28 191.439-4.756 3.977c-1.205.803-1.998.251-3.008.036a.979.979 0 0 1-.766-.969l.004-.998c-.044-1.44 1.28-2.287 2.199-2.726l4.863-2.681c.918-.439 3.928 1.116 1.464 3.361ZM101.356 185.217l1.332 6.054c.446 3.171-4.625 3.699-4.892.262l-.098-6.569c.036-1.018 2.804-2.97 3.658.253Z"
        fill="#323E48"
      />
      <Path
        d="M113.771 192.228c.012 1.471-3.567 1.501-3.58.029l-.039-4.783 3.58-.03.039 4.784ZM101.998 189.299c0 1.471-3.58 1.471-3.58 0v-4.783h3.58v4.783Z"
        fill="#A6ACB1"
      />
      <Path
        d="M102.475 187.94c-1.403 1.007-3.723.984-4.498-.187-.918-17.509-3.793-29.214-3.614-44.185l11.122-3.298c-1.984 17.973-2.193 33.762-3.01 47.67Z"
        fill="#566069"
      />
      <Path
        d="M114.173 189.576c-1.133 1.583-3.694 1.593-4.449.45l-7.494-47.21h12.922l-.979 46.76Z"
        fill="#566069"
      />
      <Path
        d="M93.916 142.344a58.729 58.729 0 0 0 .4-17.848c0-9.711 1.34-9.725 7.85-10.12l1.516-.095a10.79 10.79 0 0 1 5.393 1.06c5.749 2.795 8.534 3.448 7.368 10.346l-1.293 17.129c0 8.818-21.704 9.894-21.234-.472Z"
        fill="#D1D4D7"
      />
      <Path d="m111.574 128.642 3.183 13.218.382 1.288.468-6.371-4.033-8.135Z" fill="#7D858C" />
      <Path
        d="M102.358 110.739c1.181 2.459 4.111 2.924 5.454.96 1.343-1.965 3.17-5.861 1.989-8.32-1.18-2.459-8.111-2.325-9.454-.361-1.342 1.964.83 5.262 2.011 7.721Z"
        fill="#323E48"
      />
      <Path
        d="M42.652 98.976s4.984 2.093 13.89-9.915c1.804-2.431 4.13-11.071 4.13-11.071l-2.146-.958s-3.236 7.367-5.886 9.74c-3.556 3.186-13.298 7.48-13.72 9.089-.423 1.61 3.732 3.115 3.732 3.115Z"
        fill="#F5B335"
      />
      <Path
        opacity={0.395}
        d="M43.145 176.899c6.592-.117 11.889-2.867 11.83-6.141-.058-3.275-5.448-5.835-12.04-5.718-6.591.117-11.888 2.867-11.83 6.141.058 3.275 5.449 5.835 12.04 5.718Z"
        fill="#D4D5D7"
      />
      <Path
        d="m36.124 165.242 2.798-.351c1.87-.848 2.745-1.485 3.579-1.004l.236.137c.833.481.728 1.329-.235 1.884l-4.11 3.266a2.716 2.716 0 0 1-3.027-.294s-.46-.415-.133-2.162c.188-.996.123-1.032.892-1.476Z"
        fill="#323E48"
      />
      <Path
        d="M39.428 165.364c-.222 1.932-3.765 1.932-3.765.46l1.962-44.615 11.811-3.331-10.008 47.486Z"
        fill="#FBDDD3"
      />
      <Path
        d="m47.948 169.505 2.769.522c2.042-.235 3.068-.574 3.714.139l.183.202c.646.713.286 1.488-.799 1.723l-4.913 1.851a2.72 2.72 0 0 1-2.791-1.207s-.31-.536.537-2.098c.482-.89.431-.945 1.3-1.132Z"
        fill="#323E48"
      />
      <Path
        d="M50.206 170.688c-.617 1.561-3.322 1.22-3.276-.062 1.264-15.46-1.645-30.061-5.394-44.266l11.344-1.227c.444 16.625.296 30.87-2.674 45.555Z"
        fill="#FBDDD3"
      />
      <Path
        d="m52.18 121.11 3.945 21.653s-9.803 9.715-21.018 0l1.262-20.333 15.81-1.32Z"
        fill="#323E48"
      />
      <Path
        d="M45.88 95.136c1.985-.257 3.227-3.303 2.774-6.805-.453-3.501-2.429-6.132-4.413-5.875-1.985.257-3.227 3.303-2.774 6.805.452 3.501 2.428 6.132 4.413 5.875Z"
        fill="#FBDDD3"
      />
      <Path
        d="M51.513 91.338c-.843 2.94-3.996 4.003-5.847 2.084-1.851-1.919-2.672-5.858-1.828-8.798.844-2.94 3.03-3.767 4.882-1.848 1.853 1.92 3.637 5.622 2.793 8.562Z"
        fill="#FBDDD3"
      />
      <Path
        d="m44.383 99.821-.315-.07a1.988 1.988 0 0 1-1.503-2.367l1.338-6a1.988 1.988 0 0 1 2.367-1.504l.315.07a1.988 1.988 0 0 1 1.504 2.367l-.438 5.956c-.238 1.065-2.203 1.786-3.268 1.548Z"
        fill="#FBDDD3"
      />
      <Path
        d="M41.868 91.76s-.366 2.038 3.192 2.235c2.846.157 2-4.99 4.823-5.451 3.104-.507 3.666-4.342 2.442-5.814-1.225-1.471-4.643-2.241-7.12-1.15-2.476 1.093-7.674 1.89-3.337 10.18Z"
        fill="#715154"
      />
      <Path
        d="M49.895 90.139a1.347 1.347 0 1 1-2.59-.743 1.347 1.347 0 0 1 2.59.743Z"
        fill="#FBDDD3"
      />
      <Path
        d="M36.317 122.202c1.005-5.508-.075-9.862.012-15.719 0-10.528-.505-13.099 5.062-11.496l1.569.416c.753.201 1.483.483 2.175.841 7.339 3.781 9.298 4.947 8.975 9.333.033 7.223-3.33 8.697-1.542 15.021-1.512 4.995-14.572 5.179-16.25 1.604Z"
        fill="#F7C25D"
      />
      <Path
        d="m47.936 94.388-.319-.737a2.022 2.022 0 0 0 1.65.43c-.408.22-.868.326-1.331.307ZM42.14 88.96c1.416 0 2.564-1.334 2.564-2.978 0-1.645-1.148-2.98-2.564-2.98-1.416 0-2.564 1.335-2.564 2.98 0 1.644 1.148 2.978 2.564 2.978Z"
        fill="#323E48"
      />
      <Path
        d="M42.073 85.052a1.512 1.512 0 0 0-2.775-.902 5.86 5.86 0 0 0-.689 1.829c-1.035 4.58-8.75 3.917-4.966 11.976 0 0-3.444 5.288 2.957 7.516 3.275 1.14 3.202-7.293 3.202-7.293s1.306-3.88 2.568-6.92a5.655 5.655 0 0 0 .019-4.463 3.527 3.527 0 0 1-.316-1.743Z"
        fill="#715154"
      />
      <Path
        d="M42.913 94.679a.88.88 0 0 0-1.066 1.007 2.42 2.42 0 0 0 1.789 1.934 8.694 8.694 0 0 0 4.559.054.25.25 0 0 0 .07-.457c-1.032-.64-3.514-2.094-5.352-2.538Z"
        fill="#323E48"
      />
      <Path
        d="m68.468 85.021-1.783-1.03-.016-.006-1.325-.765c-.197-.114-.358.008-.358.271a.863.863 0 0 0 .358.686l1.784 1.029.016.007 1.324.765c.197.113.36-.008.36-.271a.862.862 0 0 0-.36-.686ZM64.487 105.922l-8.362-4.845 4.921-14.39 8.362 4.845-4.92 14.39Z"
        fill="#fff"
      />
      <Path d="m60.129 98.61-1.747-1.09 1.015-3.127 1.747 1.09-1.015 3.127Z" fill="#323E48" />
      <Path d="m62.27 99.947-1.747-1.09.664-2.043 1.747 1.09-.664 2.043Z" fill="#F7C25D" />
      <Path
        d="m64.477 101.325-1.747-1.091 1.333-4.1 1.746 1.091-1.332 4.1ZM66.42 93.664l-.881-.565-.008-.007-4.308-2.762a.278.278 0 0 0-.4.114.346.346 0 0 0 .112.444l.881.564a.101.101 0 0 0 .008.007l4.307 2.763a.278.278 0 0 0 .4-.114.346.346 0 0 0-.111-.444ZM64.94 94.615a.223.223 0 0 0-.09-.257L60.8 91.76a.277.277 0 0 0-.4.114.346.346 0 0 0 .112.444l.881.565c.003 0 .005.005.008.006l3.055 1.96a.36.36 0 0 0 .483-.232v-.002ZM61.851 94.35a.188.188 0 0 0-.08-.2l-1.409-.904a.278.278 0 0 0-.4.114.346.346 0 0 0 .112.444l.882.564c.002 0 .005.005.008.007l.521.335a.246.246 0 0 0 .333-.17l.033-.19Z"
        fill="#323E48"
      />
      <Path
        d="M47.484 104.029s7.197 17.499 15.05 9.069c7.854-8.431 5.095-14.374 5.095-14.374l-1.053-.285s-3.195 10.585-6.594 9.537c-3.4-1.047-8.019-7.582-9.654-7.891-1.635-.308-2.844 3.944-2.844 3.944Z"
        fill="#F5B335"
      />
      <Path
        d="M59.066 77.732a1.871 1.871 0 0 1-.834-2.511l.603-1.204a1.87 1.87 0 0 1 3.345 1.677l-.603 1.204a1.87 1.87 0 0 1-2.51.834ZM66.24 101.937a1.884 1.884 0 0 1-1.172-.823 1.876 1.876 0 0 1-.246-1.41l.293-1.315a1.871 1.871 0 0 1 3.652.816l-.293 1.314a1.873 1.873 0 0 1-2.234 1.418Z"
        fill="#FBDDD3"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={95.751}
        y1={99.517}
        x2={102.438}
        y2={71.432}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#7E57C5" />
        <Stop offset={0.29} stopColor="#9574CF" />
        <Stop offset={0.989} stopColor="#CCB9E8" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h210v226.787H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default LoginImage;
